import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type CallCenterShift } from "./entity";

export const CallCenterShiftEntityConfig: HyperEntityConfig<CallCenterShift> = {
  caption: "משמרות מוקד",
  allowApiRead: Roles.AdminsAndManager,
  allowApiInsert: false,
  allowApiUpdate: false,
  allowApiDelete: false,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, false);
    filter(Roles.SuperAdmin, true);
    filter(Roles.OrganizationManagers, {
      volunteer: {
        $is: {
          organization: {
            $id: remult.user.organizationId,
          },
        },
      },
    });
    filter(Roles.User, false);
  },
};
